'use client';

import { c as _c } from "react/compiler-runtime";
import type { AvatarProps as MuiAvatarProps } from '@mui/material/Avatar';
import type React from 'react';
import { default as MuiAvatar } from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
const StyledAvatar = styled(MuiAvatar)();
type AvatarProps = MuiAvatarProps;
// priority of props is: Children, then src, then alt
const Avatar: React.FC<AvatarProps> = t0 => {
  const $ = _c(13);
  let alt;
  let children;
  let props;
  let src;
  if ($[0] !== t0) {
    ({
      children,
      src,
      alt,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = children;
    $[3] = props;
    $[4] = src;
  } else {
    alt = $[1];
    children = $[2];
    props = $[3];
    src = $[4];
  }
  if (children) {
    let t1;
    if ($[5] !== alt || $[6] !== children || $[7] !== props) {
      t1 = <StyledAvatar alt={alt} {...props}>{children}</StyledAvatar>;
      $[5] = alt;
      $[6] = children;
      $[7] = props;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    return t1;
  }
  let t1;
  if ($[9] !== alt || $[10] !== props || $[11] !== src) {
    t1 = <StyledAvatar src={src} alt={alt} {...props} />;
    $[9] = alt;
    $[10] = props;
    $[11] = src;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  return t1;
};
export default Avatar;
export type { AvatarProps };